export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="flex h-16 shrink-0 items-center justify-between bg-[#f6f6f6] px-6 shadow-[inset_0_1px_0_0_#e6e6e6]">
      <span className="text-[13px] leading-5 text-[#97999b]">
        Copyright &copy; {year} Deloitte Development LLC. All rights reserved.
      </span>
      <p className="m-0 text-[13px] leading-5 text-[#97999b]">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www2.deloitte.com/us/en/legal/privacy.html"
          className="text-[#0076a8] no-underline visited:text-[#0076a8] hover:underline"
        >
          Privacy
        </a>{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://cookienotice.deloitte.com"
          className="text-[#0076a8] no-underline visited:text-[#0076a8] hover:underline"
        >
          Cookies
        </a>{' '}|{' '}
        <button
          type="button"
          className="optanon-toggle-display cursor-pointer border-none bg-transparent p-0 text-[13px] text-[#0076a8] no-underline hover:underline"
        >
          Cookie Settings
        </button>
      </p>
    </footer>
  );
}
